import { render, staticRenderFns } from "./singleUploadWithParams.vue?vue&type=template&id=15f4c1c2"
import script from "./singleUploadWithParams.vue?vue&type=script&lang=js"
export * from "./singleUploadWithParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports